import { TextField, useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../store";

export interface ISearchProps {
  setSearch: any;
}


const SearchBar = (props: ISearchProps) => {
  const { setSearch } = props

  return (
    <Box>
      <TextField
        size="small"
        fullWidth
        label="Rechercher..."
        onChange={(e) => setSearch(e.target.value)}
      />
    </Box>
  );
};
export default SearchBar;
